import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const InventoryViewType = createEnum([
  "purchase-orders",
  "shipments",
  "transfers",
  "inventory-levels",
  "catalog-products",
]);
export type InventoryViewType = z.infer<typeof InventoryViewType>;
